import { Directive, Host, Self } from "@angular/core";
import { NumericTextBoxComponent } from "@progress/kendo-angular-inputs";

// Applies to every kendo-numerictextbox so the mouse wheel never changes the value by accident.
@Directive({
  // Element selector on purpose, so it applies to every numeric textbox without editing each template.
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: "kendo-numerictextbox",
})
export class NoScrollChangeNumericTextBoxDirective {
  constructor(@Host() @Self() numericTextBox: NumericTextBoxComponent) {
    numericTextBox.changeValueOnScroll = false;
  }
}
